(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
    class ProductRecommendationsMinicart extends HTMLElement {
    constructor() {
      super();
      
      if(!window.isInit){
        fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          window.isInit = true
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations-mini-cart');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
            console.error(e);
        });
      }
      
    
    }
  }
    customElements.define('product-recommendations-mini-cart', ProductRecommendationsMinicart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.loadRecommendations();
  }

  async loadRecommendations() {
    try {
      const response = await fetch(this.dataset.url);
      const data = await response.json();
      const placeholder = document.getElementById('product-grid-placeholder');
      if (data && data.products && data.products.length) {
        // Limiter le nombre de produits à 6
        const productsToDisplay = data.products.slice(0, 6);

        productsToDisplay.forEach(recommendation => {
          console.log("Produit recommandé:", recommendation);  // Affiche la structure pour chaque produit

          if (recommendation.id !== parseInt("{{ product.id }}")) {  // Exclure le produit actuel
            const listItem = document.createElement('li');
            listItem.className = "grid__item__recommendation";
            
            const formatUrl = (url) => url.startsWith('//') ? `https:${url}` : url;
            
            const imageUrl1 = formatUrl(recommendation.featured_image || 
                              (recommendation.images && recommendation.images[0] ? recommendation.images[0] : ''));
            const imageUrl2 = recommendation.images && recommendation.images[1] ? formatUrl(recommendation.images[1]) : imageUrl1;

            const brand = recommendation.vendor || '';
            const title = recommendation.title;
            const price = recommendation.price;
            const compareAtPrice = recommendation.compare_at_price;
            const unavailableText = recommendation.tags.includes('instore-only') ? instoreOnlyText : soldOutText;
            const hasBadge = recommendation.tags.some(tag => tag.startsWith('badge_'));
            const badgeText = hasBadge ? recommendation.tags.find(tag => tag.startsWith('badge_')).replace('badge_', '').replace('-', ' ') : '';

               // Calcul du pourcentage de réduction
            let discountPercent = null;
            if (compareAtPrice != null && compareAtPrice > price) {
              const discount = compareAtPrice - price;
              discountPercent = Math.round((discount * 100) / compareAtPrice);
            }

            const formattedPrice = formatPrice(price);
            const formattedCompareAtPrice = compareAtPrice ? formatPrice(compareAtPrice) : '';
           
             const discountText = `${promotionText} -${discountPercent}%`;
       
            
            listItem.innerHTML = `
              <a href="${recommendation.url}">
                <div class="c-card-product | u-relative | u-h-fit" itemscope itemtype="http://schema.org/Product">
                  <div class="u-flex u-flex-col u-justify-between">
                    <div class="u-relative u-bg-grey-light u-rounded">
                      ${hasBadge ? `
                        <div class="c-badge | u-mt-10 u-ml-10 | u-absolute">
                          <span class="t-h4">${badgeText}</span>
                        </div>` : ''
                      }
                       ${discountPercent > 0 ? `
                        <div class="c-badge | u-mt-10 u-ml-10 | u-absolute">
                          <span class="t-h4">${discountText}</span>
                        </div>` : ''
                      }
                      <figure class="c-card-product__thumbnail | u-aspect-w-4 u-aspect-h-5">
                        <img data-src="${imageUrl1}" class="c-card-product__thumbnail__img | u-object-contain | u-rounded | lazyload" itemprop="image" alt="${title} - ${brand}" loading="lazy" />
                        ${imageUrl2 && imageUrl2 !== imageUrl1 ? `
                          <img data-src="${imageUrl2}" class="c-card-product__thumbnail__img--hover | u-object-contain | u-rounded | lazyload" itemprop="image" alt="${title} - ${brand}" loading="lazy" />
                        ` : ''}
                      </figure>
                      <div class="c-card-product__quick-buy u-px-10 u-w-full u-z-2 u-none md:u-block">
                        ${recommendation.available ? `
                          <modal-opener data-modal="#QuickAdd-${recommendation.id}">
                            <button id="quick-add-${recommendation.id}-submit" type="submit" name="add" class="quick-add__submit button t-button t-button--quickbuy u-rounded u-w-full u-pointer-events-auto " aria-haspopup="dialog" aria-labelledby="quick-add-${recommendation.id}-submit title-{{ section_id }}-${recommendation.id}" data-product-url="${recommendation.url}" >
                              <span class="t-h4">${addToCartText}</span>
                              <div class="loading-overlay__spinner hidden">
                                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                              </div>
                            </button>
                          </modal-opener>` : `
                          <button class="quick-add__submit button t-button u-rounded u-w-full u-pointer-events-none">
                            <span class="t-h4">${unavailableText}</span>
                          </button>`
                        }
                      </div>
                    </div>
                    <div class="u-mt-15">
                      <span class="t-surtitle u-block">${brand}</span>
                      <a href="${recommendation.url}" class="u-block u-text-14 3xl:u-text-[0.972vw] u-font-medium">${title}</a>
                      <div class="u-mt-10 u-flex">
                        <p class="t-surtitle t-surtitle--price">${formattedPrice}</p>
                        ${formattedCompareAtPrice ? `<del class="t-surtitle t-surtitle--price u-ml-5 u-text-grey-medium">${formattedCompareAtPrice}</del>` : ''}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <quick-add-modal id="QuickAdd-${recommendation.id}" class="quick-add-modal l-sidebar-quickbuy l-sidebar-quickbuy--right js-quickbuy-init">
                <span id="ModalClose-${recommendation.id}" class="l-sidebar-quickbuy__overlay u-block"></span>
                 <div role="dialog" aria-label="{{ 'products.product.choose_product_options' | t: product_name: ${recommendation.title} | escape }}" aria-modal="true" class="quick-add-modal__content global-settings-popup l-sidebar-quickbuy__wrapper" tabindex="-1">
                   <button id="ModalClose-${recommendation.id}" type="button" class="l-sidebar-quickbuy__close" aria-label="{{ 'accessibility.close' | t }}">
                       ${closeIconSVG}
                   </button>
                   <div id="QuickAddInfo-${recommendation.id}" class="quick-add-modal__content-info l-sidebar-quickbuy__inner"></div>
                 </div>
              </quick-add-modal>
            `;

            placeholder.appendChild(listItem);
          }
        });

        // Initialiser les modals après avoir ajouté les produits
        this.initializeModals();

        this.classList.add('product-recommendations--loaded');
      } else {
        console.warn("Aucune recommandation trouvée");
      }
    } catch (error) {
      console.error('Erreur lors du chargement des recommandations:', error);
    }
  }

  initializeModals() {
    // Sélectionnez tous les modal-openers nouvellement ajoutés
    const modalOpeners = this.querySelectorAll('modal-opener');

    modalOpeners.forEach((modalOpener) => {
      // Initialisez le modal opener
      new ModalOpener(modalOpener);
    });

    // Sélectionnez tous les quick-add-modals nouvellement ajoutés
    const quickAddModals = this.querySelectorAll('quick-add-modal');

    quickAddModals.forEach((modal) => {
      // Initialisez le quick add modal
      new QuickAddModal(modal);
    });
  }
}

// Définition de la classe ModalOpener
class ModalOpener {
  constructor(element) {
    this.element = element;
    this.modalId = this.element.getAttribute('data-modal');
    this.modal = document.querySelector(this.modalId);

    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      this.openModal();
    });
  }

  openModal() {
    if (this.modal) {
      // Ouvrir la modal immédiatement
      setTimeout(() => {
        this.modal.classList.add('is-active');
      }, 600);
    }
  }
}

// Définition de la classe QuickAddModal
class QuickAddModal {
  constructor(element) {
    this.element = element;
    this.closeButtons = this.element.querySelectorAll('[id^="ModalClose-"]');

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.closeModal();
      });
    });
  }

  closeModal() {
    this.element.classList.remove('is-active');
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function formatPrice(price) {
  return (price / 100).toFixed(2) + ' €';
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    var sections=(scope||document).querySelectorAll('.sc-faq[data-autoclose="true"]');
    sections.forEach(function(sec){
      var items=sec.querySelectorAll('.sc-faq__item');
      items.forEach(function(it){
        it.addEventListener('toggle',function(){
          if(it.open){items.forEach(function(o){if(o!==it)o.removeAttribute('open');});}
        });
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init();});}else{init();}
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
